import { render } from "./tekraraedenisForm.vue?vue&type=template&id=0509665a"
import script from "./tekraraedenisForm.vue?vue&type=script&lang=js"
export * from "./tekraraedenisForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__